<wms-dialog-header title="{{locale['LABEL_SESSION_TIMEOUT']}}"></wms-dialog-header>
<wms-dialog-body>
  <wms-message *ngIf="msgData.show" hideclose="true" [scopeDataset]="msgData"></wms-message>
  <p class="info">{{locale['MESSAGE_SESSION_TIMEOUT_LOGIN']}}</p>
</wms-dialog-body>
<wms-dialog-footer>
  <button class="button-primary btn app-button" title="{{locale.LABEL_LOGIN}}" (click)="login()" [disabled]="isLoginInProgress">
    <span class="btn-caption">{{locale.LABEL_LOGIN}}</span>
  </button>
</wms-dialog-footer>
